import React, { useState, useEffect } from "react";
import { Modal, Spin } from "antd";
import { isFormComplete } from "../../util/util";
import SuccessImg from "../../assets/UiElements/correct.svg";
import Navigate from "../../components/Navigate";
import { useChangePassword } from "../../hooks/useAuth";
import { useModalWidth } from "../../hooks/useModalWidth";


const Settings = () => {
  const modalWidth = useModalWidth();
  const [form, setForm] = useState({
    old_password: "",
    password: "",
    c_password: "",
  });
  const changePasswordMutation = useChangePassword();
  const [loading, setLoading] = useState(false);
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Delay rendering of omk-text-field until after mount
  useEffect(() => {
    setMounted(true);
  }, []);

  const togglePasswordType = (field) => {
    if (field === "oldPassword") {
      setOldPasswordType(oldPasswordType === "password" ? "text" : "password");
    } else if (field === "newPassword") {
      setNewPasswordType(newPasswordType === "password" ? "text" : "password");
    } else if (field === "confirmPassword") {
      setConfirmPasswordType(
        confirmPasswordType === "password" ? "text" : "password"
      );
    }
  };


  const changeHandler = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // Password criteria
  const password = form.password;
  const confirmPassword = form.c_password;
  const criteria = {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    hasNumber: /\d/.test(password),
  };
  const isPasswordValid = Object.values(criteria).every(Boolean);

  const submitPasswordChange = async () => {
    if (!isPasswordValid) {
      window.notifyUser && window.notifyUser('error', 'Password must match all requirements', 'Validation Error');
      return;
    }
    if (password !== confirmPassword) {
      changePasswordMutation.reset && changePasswordMutation.reset();
      window.notifyUser && window.notifyUser(
        "error",
        "New password and confirmation do not match!",
        "Validation Error"
      );
      return;
    }
    if (isFormComplete(form)) {
      setLoading(true);
      try {
        await changePasswordMutation.mutateAsync({
          old_password: form.old_password,
          password: form.password,
          c_password: form.c_password,
        });
        setIsModalVisible(true);
      } catch (error) {
        // Error notification handled in hook
      } finally {
        setLoading(false);
      }
    } else {
      changePasswordMutation.reset && changePasswordMutation.reset();
      window.notifyUser && window.notifyUser("error", "All fields are required!", "Validation Error");
    }
  };

  const isButtonDisabled =
    !form.old_password || !form.password || !form.c_password;

  return (
    <div className="container p-0">
     
      <br/><br/><br/>
      <div
        className="mx-auto mobile-full-width shadow bg-white p-5 login-width"
        style={{
          borderRadius: "20px", 
          width: "90%", 
          maxWidth: "700px", 
        }}
      >
        {/* Card Header */}
        <div style={{ 
          borderBottom: '2px solid #eee', 
          paddingBottom: '16px', 
          marginBottom: '24px',
          textAlign: 'left'
        }}>
          <h2 style={{ 
            fontWeight: 700, 
            fontSize: '24px', 
            color: '#222',
            margin: 0 
          }}>
            Reset Password
          </h2>
        </div>
        
        <div align="center">
          <div className="mt-4 w-750 mx-auto mobile-full-width">
            <Spin spinning={loading}>
              {mounted && (
                <omk-text-field
                  label="Enter Old Password"
                  value={form.old_password}
                  type={oldPasswordType}
                  className="mb-4"
                  onInput={changeHandler}
                  name="old_password"
                  style={{
                    marginBottom: "20px",
                    borderRadius: "50px",
                    padding: "12px",
                    width: "100%",
                  }}
                >
                  <omk-icon
                    slot="trailing-icon"
                    onClick={() => togglePasswordType("oldPassword")}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        oldPasswordType === "password"
                          ? "bi bi-eye-slash"
                          : "bi bi-eye"
                      }
                    />
                  </omk-icon>
                </omk-text-field>
              )}


              {mounted && (
                <omk-text-field
                  label="Enter New Password"
                  value={form.password}
                  type={newPasswordType}
                  className="mb-4"
                  onInput={changeHandler}
                  name="password"
                  style={{
                    marginBottom: "20px",
                    borderRadius: "50px",
                    padding: "12px",
                    width: "100%",
                  }}
                >
                  <omk-icon
                    slot="trailing-icon"
                    onClick={() => togglePasswordType("newPassword")}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        newPasswordType === "password"
                          ? "bi bi-eye-slash"
                          : "bi bi-eye"
                      }
                    />
                  </omk-icon>
                </omk-text-field>
              )}

              {/* Password criteria UI */}
              {password && (
                <div className="row mb-4">
                  <div className="col-6">
                    <small className="float-start">
                      {criteria.minLength ? (
                        <i className="bi bi-check-lg text-success" style={{ marginRight: '5px' }} />
                      ) : (
                        <i className="bi bi-x-lg text-danger" style={{ marginRight: '5px' }} />
                      )}
                      Min 8 characters
                    </small><br />
                    <small className="float-start">
                      {criteria.hasUppercase ? (
                        <i className="bi bi-check-lg text-success" style={{ marginRight: '5px' }} />
                      ) : (
                        <i className="bi bi-x-lg text-danger" style={{ marginRight: '5px' }} />
                      )}
                      An uppercase
                    </small>
                  </div>
                  <div className="col-6">
                    <small className="float-start">
                      {criteria.hasSpecialChar ? (
                        <i className="bi bi-check-lg text-success" style={{ marginRight: '5px' }} />
                      ) : (
                        <i className="bi bi-x-lg text-danger" style={{ marginRight: '5px' }} />
                      )}
                      A special character
                    </small><br />
                    <small className="float-start">
                      {criteria.hasNumber ? (
                        <i className="bi bi-check-lg text-success" style={{ marginRight: '5px' }} />
                      ) : (
                        <i className="bi bi-x-lg text-danger" style={{ marginRight: '5px' }} />
                      )}
                      A number
                    </small>
                  </div>
                </div>
              )}

              {mounted && (
                <omk-text-field
                  label="Confirm New Password"
                  value={form.c_password}
                  type={confirmPasswordType}
                  className="mb-4"
                  onInput={changeHandler}
                  name="c_password"
                  style={{
                    marginBottom: "20px",
                    borderRadius: "50px",
                    padding: "12px",
                    width: "100%",
                  }}
                />
              )}

              <button
                className={`btn ${
                  isButtonDisabled ? "btn-secondary" : "btn-primary"
                } mb-4 w-50`}
                onClick={submitPasswordChange}
                disabled={isButtonDisabled}
                style={{
                  borderRadius: "50px",
                  padding: isButtonDisabled ? "5px 20px" : "10px 20px",
                  height: "auto",
                }}
              >
                Continue
              </button>
            </Spin>
          </div>
        </div>
      </div>

      <Modal visible={isModalVisible} footer={null} centered width={modalWidth}>
        <div align="center">
          <img src={SuccessImg} alt="Success" className="img-fluid mb-5" />
          <p className="lead fw-bold">Password Updated Successfully!</p>
          <small>
            Your password has been changed successfully. Keep it safe.
          </small>
          <div className="mt-4 w-75 mx-auto">
            <Navigate path="/dashboard">
              <button className="btn btn-primary mb-4 w-50 mobile-full-width">
                Close
              </button>
            </Navigate>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Settings;
